export class Forms {
  
  constructor() {
      this.init();
  };

  init() {
    
    const formRange = document.querySelectorAll('.form-group input[type=range]');
    
    if(formRange.length) {
      formRange.forEach(element => {
        element.addEventListener('click', event => {
        var cssval = "w" + element.value * 10;
          element.removeAttribute('class');
          element.classList.add('form-control');
          element.classList.add(cssval);
        });
      });
    }

  };

};
